export default __webpack_public_path__ + "static/media/bg-banner-1.78d95531.jpg";